import React, { useEffect, useRef, useState } from 'react';
import { IconButton } from '@mui/material';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { MoreOptions } from '../Table/assets/MoreOptions';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { formatNumber } from '../../reducer/actions/formatNumber';
import { DoneRounded } from '@mui/icons-material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useDrag, useDrop } from 'react-dnd';
import Tooltip from '@mui/material/Tooltip';
import { htmlToText } from 'html-to-text';
import {useStateContext} from "../../hooks/useStateContext";
import {hasPermissionId} from "../../core/permissions/hasPermissionId";
import {hasPermissionByPriority} from "../../core/permissions/hasPermission";
import {ROLE_PRIORITIES} from "../../core/permissions/permissions";

const ItemTypes = {
  BOX: 'ROW',
};

const ServiceProviderServiceRow = ({
  row,
  index,
  type,
  notes,
  moveRow,
  clickOnEdit,
  clickOnDelete,
  openViewPrices,
}) => {
  const ref = useRef(null);

  const [{ isDragging }, drag] = useDrag({
    item: { type: ItemTypes.BOX },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [, drop] = useDrop({
    accept: 'ROW',
    hover: (draggedItem) => {
      if (draggedItem.index !== index) {
        moveRow(draggedItem.index, index);
        draggedItem.index = index;
      }
    },
  });

  drag(drop(ref));

  const divRef = useRef(null);
  const [tooltip, setTooltip] = useState(false);

  function getDivWidth(divRef) {
    if (divRef && divRef.current) {
      const divElement = divRef.current;
      const parentElement = divElement.parentNode;

      const divRect = divElement.getBoundingClientRect();
      const parentRect = parentElement.getBoundingClientRect();

      return {
        element: divRect.width,
        cell: parentRect.width,
      };
    }
    return {
      element: 0,
      cell: 0,
    };
  }

  // TODO: this uses a lot of memory
  useEffect(() => {
    setTooltip(false);
    const divWidth = getDivWidth(divRef);

    if (divWidth['element'] > divWidth['cell']) {
      setTooltip(true);
    }
  });

  const {user} = useStateContext();
  const isFinance = hasPermissionId(user.roles, 101);
  const isAdmin = hasPermissionByPriority(user.roles, ROLE_PRIORITIES[1]);

  return (
    <>
      <TableRow
        ref={ref}
        style={{ opacity: isDragging ? 0.5 : 1 }}
        sx={{
          '& .MuiTableCell-root': {
            overflowWrap: 'anywhere',
          },
        }}
      >
        <TableCell
          sx={{
            padding: '5px',
          }}
        >
          <MoreOptions
            disabledDelete={!isAdmin}
            disabledEdit={(!(isAdmin || isFinance))}
            clickOnEdit={() => {
              clickOnEdit();
            }}
            clickOnDelete={() => {
              clickOnDelete();
            }}
          />
        </TableCell>
        <TableCell
          sx={{
            cursor: 'pointer',
            padding: '5px',
            '&:hover': {
              background: '#f3f3f3',
            },
          }}
          onClick={() => {
            clickOnEdit();
          }}
        >
          {row?.name}
        </TableCell>
        <TableCell
          sx={{
            padding: '5px',
          }}
        >
          {row?.price_refresh_date}
        </TableCell>
        <TableCell
          sx={{
            padding: '5px',
          }}
        >
          {row?.valid_from}
        </TableCell>
        <TableCell
          sx={{
            padding: '5px',
          }}
        >
          {row?.valid_to}
        </TableCell>
        <TableCell
          sx={{
            padding: '5px',
          }}
        >
          {row?.service_type?.name}
        </TableCell>
        <TableCell
          sx={{
            padding: '5px',
          }}
        >
          {row?.staff_required ? (
            <DoneRounded color={'success'} />
          ) : (
            <CloseRoundedIcon color={'disabled'} />
          )}
        </TableCell>
        <TableCell
          sx={{
            maxWidth: '200px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          <Tooltip
            title={
              tooltip ? <div dangerouslySetInnerHTML={{ __html: notes }} /> : ''
            }
            placement={'bottom-start'}
          >
            <span ref={divRef}>{htmlToText(notes)}</span>
          </Tooltip>
        </TableCell>
        <TableCell
          align={'right'}
          sx={{
            padding: '5px',
          }}
        >
          {type === 'unit' ? (
            <>
              {row?.unit_price
                ? formatNumber(row?.unit_price)
                : !row?.unit_price && row?.unit_price_gross
                ? formatNumber(row?.unit_price_gross)
                : ''}
            </>
          ) : (
            <>
              <IconButton
                onClick={() => {
                  openViewPrices();
                }}
              >
                <VisibilityOutlinedIcon color={'primary'} />
              </IconButton>
            </>
          )}
        </TableCell>
        <TableCell
          align={'right'}
          sx={{
            padding: '5px',
          }}
        >
          {type === 'unit' ? (
            <>
              {row?.unit_price_gross
                ? formatNumber(row?.unit_price_gross)
                : !row?.unit_price_gross && row?.unit_price
                ? formatNumber(row?.unit_price)
                : ''}
            </>
          ) : (
            <></>
          )}
        </TableCell>
        <TableCell
          align={'left'}
          sx={{
            padding: '5px',
          }}
        >
          {row?.currency?.name}
        </TableCell>
        <TableCell
          align={'right'}
          sx={{
            padding: '5px',
          }}
        >
          {row?.vat ? `${row.vat} %` : `0 %`}
        </TableCell>
      </TableRow>
    </>
  );
};
export default ServiceProviderServiceRow;
